import { api } from '@/api/client'

export type AdminNotificationCategory =
  | 'tickets'
  | 'orders'
  | 'payments'
  | 'messages'
  | 'livechat'
  | 'adverts'
  | 'wallet'
  | 'other'

export type AdminNotificationItem = {
  id: number
  type: string
  category: AdminNotificationCategory | string
  title: string
  body: string | null
  href: string | null
  meta: Record<string, unknown>
  unread: boolean
  created_at: string | null
}

export type AdminNotificationsPayload = {
  items: AdminNotificationItem[]
  unread_count: number
  counts_by_category: Record<string, number>
}

export async function fetchAdminNotifications(opts?: {
  limit?: number
  category?: AdminNotificationCategory | string
}): Promise<AdminNotificationsPayload> {
  const { data } = await api.get<{ success: boolean; data: AdminNotificationsPayload }>(
    '/admin/notifications',
    {
      params: {
        limit: opts?.limit ?? 40,
        ...(opts?.category ? { category: opts.category } : {}),
      },
    },
  )
  return data.data
}

export async function fetchAdminNotificationsUnreadCount(): Promise<{
  count: number
  counts_by_category: Record<string, number>
}> {
  const { data } = await api.get<{
    success: boolean
    data: { count: number; counts_by_category: Record<string, number> }
  }>('/admin/notifications/unread-count')
  return data.data
}

export async function markAdminNotificationRead(id: number): Promise<number> {
  const { data } = await api.post<{
    success: boolean
    data: { unread_count: number }
  }>(`/admin/notifications/${id}/read`)
  return data.data.unread_count
}

export async function markAllAdminNotificationsRead(
  category?: AdminNotificationCategory | string,
): Promise<number> {
  const { data } = await api.post<{
    success: boolean
    data: { unread_count: number }
  }>('/admin/notifications/read-all', category ? { category } : {})
  return data.data.unread_count
}
